// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Dealer } from './dealer';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SalesRep extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  deleted?: Date;
  displayName?: string;
  displayOrder?: number;
  email?: string;
  name?: string;
  sendSalesOrders!: boolean;
  dealers!: Dealer[];
}

